import { MentionMeDomainConfig } from './mention-me-domain-config.interface';

export interface MentionMeConfig extends MentionMeDomainConfig {
  mentionMeApi?: string;
}
